<con-page-layout>
  <con-page-header header="Set Maintenance Schedule"></con-page-header>
  <con-page-layout-content>
    <mat-error *ngIf="error">{{ error }}</mat-error>
    <form (ngSubmit)="onSubmit()" *ngIf="tenant" #form="ngForm" novalidate>
      <mat-card>
        <mat-card-content>
          <mat-form-field>
            <mat-label>Account Name</mat-label>
            <input type="text" matInput readonly [(ngModel)]="tenant.connectAccountName" name="connectAccountName" maxlength="100" #connectAccountName="ngModel" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>AUnique</mat-label>
            <input type="text" matInput readonly [(ngModel)]="tenant.aUnique" name="AUnique" maxlength="100" #aUnique="ngModel" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Folder Name</mat-label>
            <input type="text" matInput readonly [(ngModel)]="tenant.connectFolderName" name="connectFolderName" maxlength="100" #connectFolderName="ngModel" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Folder Region</mat-label>
            <input type="text" matInput readonly [(ngModel)]="tenant.connectFolderRegion" name="connectFolderRegion" maxlength="100" #connectFolderRegion="ngModel" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Maintenance Start Time</mat-label>
            <mat-datepicker-toggle matPrefix [for]="startPicker"></mat-datepicker-toggle>
            <input readonly matInput [ngxMatDatetimePicker]="startPicker" [(ngModel)]="tenant.maintenanceStartTime" name="maintenanceStartTime" [min]="minDate" #maintenanceStartTime="ngModel" />
            <ngx-mat-datetime-picker #startPicker [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="false" [color]="'primary'" [enableMeridian]="false"> </ngx-mat-datetime-picker>
            <mat-hint> Maintenance Start Time should be in GMT Timezone and format is mm/dd/yyyy HH:MM</mat-hint>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Maintenance End Time</mat-label>
            <mat-datepicker-toggle matPrefix [for]="endPicker"></mat-datepicker-toggle>
            <input readonly matInput [ngxMatDatetimePicker]="endPicker" [(ngModel)]="tenant.maintenanceEndTime" name="maintenanceEndTime" [min]="minDate" #maintenanceEndTime="ngModel" />
            <ngx-mat-datetime-picker #endPicker [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [stepSecond]="1" [touchUi]="false" [color]="'primary'" [enableMeridian]="false"> </ngx-mat-datetime-picker>
            <mat-hint> Maintenance End Time should be in GMT Timezone and format is mm/dd/yyyy HH:MM</mat-hint>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Maintenance Notes</mat-label>
            <textarea rows="2" cols="50" matInput [(ngModel)]="tenant.maintenanceNotes" name="maintenanceNotes" maxlength="2000" #maintenanceNotes="ngModel" required></textarea>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <div class="form-actions">
        <button mat-raised-button type="submit" color="primary" [disabled]="!isMaintenanceWindowValid()">
          {{ "save" | translate }}
        </button>
        <a mat-raised-button [routerLink]="['/maintenance']">{{ "cancel" | translate }}</a>
      </div>
    </form>
  </con-page-layout-content>
</con-page-layout>
